/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SceneIdListModel
 */
export interface SceneIdListModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof SceneIdListModel
     */
    scenes: Array<number>;
}

export function SceneIdListModelFromJSON(json: any): SceneIdListModel {
    return SceneIdListModelFromJSONTyped(json, false);
}

export function SceneIdListModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SceneIdListModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scenes': json['scenes'],
    };
}

export function SceneIdListModelToJSON(value?: SceneIdListModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scenes': value.scenes,
    };
}

